"use client";

import { useState, useEffect } from 'react';
import Image from "next/image";
import { ClockCircleOutlined, DownOutlined } from '@ant-design/icons';

export type EventCardProps = {
  data: EventDataType
};

type EventDataType = {
  insightSourceAuthorIcons: string[],
  insightSourceCountStr: string,
  paulInsight: string
}

export const ViewMore: React.FC<EventCardProps> = ({
  data,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEnable, setIsEnable] = useState(true);
  const [charIdx, setCharIdx] = useState(0);
  const arrTxt = data.paulInsight?.split('') || []

  function isElementClippedByOverflow(element: HTMLSpanElement) {
    // 获取元素的边界矩形
    const elementRect = element.getBoundingClientRect();

    // 递归检查所有祖先元素
    let parent = element.parentElement;
    while (parent) {
      // 获取父元素的计算样式
      const parentStyle = window.getComputedStyle(parent);

      // 检查父元素是否设置了overflow:hidden
      if (parentStyle.overflow === 'hidden' ||
        parentStyle.overflowX === 'hidden' ||
        parentStyle.overflowY === 'hidden') {

        // 获取父元素的边界矩形
        const parentRect = parent.getBoundingClientRect();

        // 检查子元素是否超出父元素的可视区域
        const isClipped = (
          // 子元素顶部超出父元素顶部
          elementRect.top < parentRect.top ||
          // 子元素底部超出父元素底部
          elementRect.bottom > parentRect.bottom ||
          // 子元素左侧超出父元素左侧
          elementRect.left < parentRect.left ||
          // 子元素右侧超出父元素右侧
          elementRect.right > parentRect.right
        );

        if (isClipped) {
          return {
            isClipped: true,
            parent: parent,
            reason: 'overflow-hidden'
          };
        }
      }

      // 继续检查上一级父元素
      parent = parent.parentElement;
    }

    // 未被任何设置overflow:hidden的父元素裁剪
    return {
      isClipped: false
    };
  }

  useEffect(() => {
    const chars = document.querySelectorAll('.char');
    let delay = 0;
    let idx = 0
    chars.forEach((char, index) => {
      // 每个字符的延迟时间：行之间有较大间隔，字符之间有小间隔
      // delay += 7 * 1000 / arrTxt.length;
      // setTimeout(() => {
      //   // @ts-ignore
      //   char.style.opacity = 1;
      // }, delay);

      if (isElementClippedByOverflow(char as HTMLSpanElement).isClipped) {
        // @ts-ignore
        // char.style.opacity = 1;
        if (idx === 0) {
          idx = index
          setCharIdx(index)
        }
        // console.log("index : ", index)
        char.classList.add("char-op-0")
      }
    });
  }, [data.paulInsight])

  useEffect(() => {
    if (isOpen) {
      setIsEnable(false)
      let delay = 0;
      const chars = document.querySelectorAll('.char');
      chars.forEach((char, index) => {
        if (index >= charIdx) {
          delay += 7 * 1000 / arrTxt.length
          setTimeout(() => {
            char && char.classList.add("char-op-1")
          }, delay);
        }
      });
      setTimeout(() => {
        setIsEnable && setIsEnable(true)
      }, delay)
    } else {
      document.querySelectorAll('.char-op-1').forEach((char, index) => {
        char.classList.remove("char-op-1")
      });
    }
  }, [isOpen])

  return (<>
    {
      arrTxt.length ?
        <div
          className={`leading-24 text-15 ${isOpen ? " line-clamp-none h-auto " : " line-clamp-4 h-96 "}`}
          style={{ color: '#76A5FF', transition: 'all 3s' }}
        >
          {arrTxt.map((item, index) => (<span className='char' key={index} data-id={"id-" + index}>{item}</span>))}
        </div>
        :
        null
    }
    {
      data.insightSourceAuthorIcons ?
        <div className='mt-14 flex items-center justify-between'>
          <div className='flex items-center'>
            <div className='relative flex items-center'>
              {
                data.insightSourceAuthorIcons.map((item, index) => (
                  <Image
                    src={item}
                    alt='insightSourceAuthorIcons'
                    className={`w-24 h-24 relative rounded-full z-[${index + 1}]`}
                    width={24} height={24} key={index}
                    style={{ marginLeft: index ? '-1rem' : 0 }} />
                ))
              }
            </div>
            <span className='text-sm text-bravve-sub-500 ml-5'>{data.insightSourceCountStr}</span>
          </div>
          <div className='flex items-center' onClick={() => {
            isEnable && setIsOpen(!isOpen)
          }}>
            <span className='text-sm text-bravve-200 cursor-pointer'>View More</span>
            <DownOutlined
              className='ml-5'
              style={
                isOpen ?
                  { color: "#fff", transform: "rotate(-180deg)", transition: 'transform 0.3s ease-in-out' }
                  :
                  { color: "#fff", transform: "rotate(0deg)", transition: 'transform 0.3s ease-in-out' }
              }
            />
          </div>
        </div>
        :
        null
    }

  </>)
}